import { Controller } from "@hotwired/stimulus"
import TomSelect from "@lib/custom-tom-select"
import { get as getFetch } from "@lib/requests"

// Connects to data-controller="act-items"
export default class extends Controller {

  static targets = ["group", "act", "clinic", "container", "header", "body", "row", "submit"]
  
  connect() {
    if (!this.hasActTarget) return

    // Destroy existing Tom Select instance if it exists (e.g., from previous connection)
    if (this.actTarget.tomselect) {
      this.actTarget.tomselect.destroy()
    }

    this.actSelect = new TomSelect(this.actTarget, { 
      load: this.loadActs.bind(this),
      searchField: [],
      onChange: this.onActSelect.bind(this),
      shouldLoad: function(query) {
        return true;  // Always trigger the load function (so we can clear the options on blank queries)
      }
    })
    // Store initial options
    this.actSelect.setInitialOptions(this.actSelect.options)
    this.actSearchNavigated = false
    this.ignoreInitialEnterSelection(this.actSelect, () => this.actSearchNavigated, value => this.actSearchNavigated = value)
    this.actSelect.focus()
  }

  disconnect() {
    if (this.actSelect) {
      this.actSelect.destroy()
    }
  }

  clinicChange(e) {
    this.actSelect.clearOptions()
    this.actSelect.focus()
  }

  get rows() {
    return this.rowTargets
  }

  get hiddenForm() {
    return !this.rows.length
  }

  get disabledForm() {
    return this.hiddenForm || [...this.rows].every(row => row.dataset.disabled !== undefined)
  }

  get inMainSearchInput() {
    return this.actTarget.tomselect?.control?.contains(document.activeElement)
  }

  async loadActs(query, callback) {
    // Clear both the selection and options
    this.actSelect.clear(true)
    this.actSelect.clearOptions()
    
    if (!query.trim()) {
      // Restore initial options when query is cleared
      callback(this.actSelect.initialOptions)
      return
    }
    
    let url = `/api/v1/acts?q=${query}`
    url += this.clinicTarget.value ? `&clinic=${this.clinicTarget.value}` : ""
    const response = await fetch(url, { headers: { accept: "application/json" } })
    const acts = await response.json()
    callback(acts || [])
  }
  
  updateFormStatus() {
    // this.hiddenForm ? this.tableTarget.classList.add("hidden") : this.tableTarget.classList.remove("hidden")
    this.hiddenForm ? this.headerTarget.classList.add("hidden") : this.headerTarget.classList.remove("hidden")
    this.disabledForm ? this.submitTarget.setAttribute("disabled", "disabled") : this.submitTarget.removeAttribute("disabled")
  }
  
  async onActSelect(value) {
    if (!value) return

    this.actSelect.clearSelect()
    this.actSearchNavigated = false
    const group = this.groupTarget.value
    await getFetch(`/act-groups/${group}/add-row?act_id=${value}`, { responseKind: "turbo-stream" })
    setTimeout(this.updateFormStatus.bind(this), 100)
  }

  ignoreInitialEnterSelection(select, hasNavigated, setNavigated) {
    const originalOnKeyDown = select.onKeyDown

    select.hook("instead", "onKeyDown", event => {
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        setNavigated(true)
      }

      if (event.key === "Enter" && !select.inputValue().trim() && !hasNavigated()) {
        event.preventDefault()
        event.stopPropagation()
        return
      }

      return originalOnKeyDown.call(select, event)
    })
  }

  submitOnEnter(event) {
    if (event.isComposing || this.inMainSearchInput || this.disabledForm) return

    event.preventDefault()
    this.element.requestSubmit(this.submitTarget)
  }

  delete(e) {
    e.target.closest("[data-act-items-target='row']").remove()
    this.updateFormStatus()
  }

}
